import { LocationQueryValue } from 'vue-router';

function toInt(val: string | LocationQueryValue[] | null): number {
  if (!val) return 0;
  if (typeof val === 'number') return val;
  if (typeof val === 'string') return parseInt(val, 10) || 0;
  return 0;
}

export default toInt;
